var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SignupLayout',[_c('NsHeader',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('nuxt',{attrs:{"slot":"app"},slot:"app"}),_vm._v(" "),_c('NsFooter',{attrs:{"slot":"footer"},slot:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }